import { Outlet } from "react-router-dom"
import useRefreshToken from "src/hooks/useRefreshToken"
import useAuth from "src/hooks/useAuth"
import { useState, useEffect } from "react"
import { decryptObject } from "src/lib/crypt"
import axios from "src/axios/axios"
import { getCookie } from "src/functions/general/cookies"

const PersistLogin = () => {
  const [isLoading, setisLoading] = useState(true);
  const refresh = useRefreshToken();
  const { auth, setAuth } = useAuth();

  useEffect(()=>{
    let isMounted = true;

    const verifyRefreshToken = async () => {
        
        try {
          const jwt = getCookie("jwt");
          if(jwt){
            const decrypt = decryptObject(jwt, process.env.REACT_APP_SECRET!)
            if('username' in decrypt && 'password' in decrypt && 'clientcode' in decrypt){
              const { data } = await axios.post(`authenticate`, {
                clientcode: decrypt.clientcode,
                username: decrypt.username,
                password: decrypt.password, 
              })
              if(data.errorcode===0){
                setAuth({status:'authenticated', data: data.object})
              }
            }
           
          }
            //await refresh();
        } 
        catch (error) {
            console.error(error);
        }
        finally {
            isMounted && setisLoading(false);
        }
    }

    !auth?.data?.token ? verifyRefreshToken() : setisLoading(false);

    return () => {
        isMounted = false;
    }
  }, [])

  return (
    <>
        {isLoading 
                ?
                <p>Even geduld...</p>
                :
                <Outlet />
        }
    </>
  )
}

export default PersistLogin